import * as Services from "../services/Services"
import * as Url from "../services/Url"


export const getAllTask = async() => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_TASKS, token)
  return res;
};

export const getAllTaskbyContractor = async(tenant_id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_TASKS_BY_CONTRACTOR+tenant_id, token)
  return res;
};

export const getTaskDetails = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GET_TASK_DETAILS}/${id}`, token)
  return res;
};

export const addTask = async(payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_TASK, payload, token)
  return res;
};
export const updateTask = async(id, payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.PUT(`${Url.UPDATE_TASK}/${id}`, payload, token)
  return res;
};
export const deleteTaskByID = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.DELETE(`${Url.DELETE_TASK}/${id}`, {}, token)
  return res;
};

export const addTaskLog = async(payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_TASKLOG, payload, token)
  return res;
};

export const getAllTaskLogbyEmployee = async(employee, startDate, endDate) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_TASKLOG_BY_EMPLOYEE+employee+"&startDate="+startDate+"&endDate="+endDate, token)
  return res;
};

export const updateTaskLog = async(id, payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.PUT(`${Url.UPDATE_TASKLOG}/${id}`, payload, token)
  return res;
};
export const deleteTaskLogByID = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.DELETE(`${Url.DELETE_TASKLOG}/${id}`, {}, token)
  return res;
};

export const getAllDailyTaskLogbyEmployee = async(employee, date) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_DAILY_TASKLOG_BY_EMPLOYEE+employee+"&date="+date, token)
  return res;
};

export const getAllTaskLogbyContractor = async(tenant_id, employee, startDate, endDate) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_TASK_LOGS_BY_CONTRACTOR+"tenant_id="+tenant_id+"&employee="+employee+"&startDate="+startDate+"&endDate="+endDate, token)
  return res;
};

export const getEmployeeInvoiceLogs = async(employee, startDate, endDate) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_EMPLOYEE_INVOICE+"employee="+employee+"&startDate="+startDate+"&endDate="+endDate, token)
  return res;
};

export const getAllTaskLogbyTenant = async(tenant_id, employee, startDate, endDate) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_TASK_LOGS_BY_TENANT+"tenant_id="+tenant_id+"&employee="+employee+"&startDate="+startDate+"&endDate="+endDate, token)
  return res;
};

export const getAllTaskLogbyEmployeePagination = async(employee, page, pageSize) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_TASKLOG_BY_EMPLOYEE_PAGINATION+"employee="+employee+"&page="+page+"&pagesize="+pageSize, token)
  return res;
};


